/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-underscore-dangle */
import { Button, Card, CardContent, Container, Grid, Tab, Tabs, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Notification } from 'rsuite';
import iconCheckGreen from '../../../assets/icons/icon_check_circle_green.svg';
import { AlertWithTimestamp } from '../../../components/AlertWithTimestamp';
import Exception from '../../../data/Exception';
import { canOpenIpaSettings, isProductRule } from '../../../utils/ipaAccess';
import { SetupIPA, SetupInfopanel } from './Components';
import InfoPanelConfig from './InfoPanel';
import MpdvConfig from './MPDV';

import { getProductConfig, saveProductConfig } from './services';
const StyledTabs = withStyles({
  root: {
    minHeight: 36,
    marginTop: 8,
  },
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    '& > span': {
      // marginTop: -20,
      height: 2,
      width: '100%',
      backgroundColor: '#378EF0',
    },
  },
})(Tabs);

const StyledTab = withStyles(theme => ({
  root: {
    textTransform: 'none',
    color: 'var(--gray-900, #323232)',
    fontFamily: "'Open Sans', sans-serif",
    fontSize: 14,
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: '20px',
    minHeight: 36,
    minWidth: 'auto',
    padding: '8px 12px',
    marginRight: theme.spacing(0.5),
    '&:focus': {
      opacity: 1,
    },
    '&:first-child': {
      paddingLeft: 0,
    },
    '&$disabled': {
      color: 'var(--gray-600, #959595)',
      opacity: 0.75,
    },
  },
  selected: {
    color: '#378EF0',
  },
  disabled: {},
}))(Tab);

const ProductConfigCard = withStyles({
  root: {
    padding: '8px 16px 0',
  },
})(Card);

const ProductConfigCardContent = withStyles({
  root: {
    padding: 0,
    '&:last-child': {
      paddingBottom: 0,
    },
  },
})(CardContent);

const ProductConfigTitle = withStyles({
  root: {
    fontFamily: "'Open Sans', sans-serif",
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: 20,
    lineHeight: '26px',
    color: '#323232',
  },
})(Typography);

const TabPanel = ({ children, value, index }) => (
  <div role="tabpanel" hidden={value !== index} id={`inf-tabpanel-${index}`} aria-labelledby={`inf-tab-${index}`} style={{ width: '100%', padding: '8px' }}>
    {value === index && (
      <Grid container spacing={2}>
        {children}
      </Grid>
    )}
  </div>
);

const a11yProps = index => ({
  id: `simple-tab-${index}`,
  'aria-controls': `simple-tabpanel-${index}`,
});

const ROUTES = {
  ISA_ANALISE_COBERTURAS: '/administrador/produtos/ISA/coberturas',
  ADMINISTRADOR_PESSOAS: '/administrador/pessoas',
  ADMINISTRADOR_PRODUTOS: '/administrador/produtos',
};

const ProductsConfigPage = ({ usuario }) => {
  const history = useHistory();
  const location = useLocation();
  const currentPath = location.pathname;

  const [tabValue, setTabValue] = useState(null);
  const [productConfigData, setProductConfigData] = useState('');

  const panelFree = usuario?.servicoPanel?.pacotePainel?.name === 'FREE';
  const panelRoutes = panelFree ? ROUTES.ADMINISTRADOR_PRODUTOS : ROUTES.ISA_ANALISE_COBERTURAS;

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const productRule = isProductRule(usuario);

  const permissions = {
    IPA: productRule ? canOpenIpaSettings(usuario) : usuario?.servicos?.some(({ name }) => name === 'IPA'),
    PAN: usuario?.servicos?.some(({ name }) => name === 'PAN'),
  };

  const ipaTabLabel = productRule ? 'IPA' : 'IPA | Software de Precificação';

  const getProductConfigData = async () => {
    const cliente = JSON.parse(localStorage.getItem('cliente'))?.codigo;
    const resp = await getProductConfig(cliente);

    if (resp?.data !== '') {
      setProductConfigData(resp?.data);
    } else {
      setProductConfigData('');
    }
  };

  const handleSaveProductConfig = async (type, data) => {
    const resp = await saveProductConfig(type, data);

    if (resp.status === 200) {
      Notification.open({
        className: 'product-config-success-notification',
        description: (
          <>
            <img src={iconCheckGreen} alt="" />
            <p>Suas configurações foram salvas com sucesso.</p>
          </>
        ),
      });
      getProductConfigData();
    } else {
      console.error(resp.status);
    }
  };

  const setStartTab = usuario => {
    const TABS = {
      IPA: 2,
      ISA: 0,
      SERVICO_COLETA: 1,
      NONE: null,
    };

    const canAccessIPA = productRule ? permissions.IPA : usuario?.uploadPermitido || permissions.IPA;

    if (currentPath.includes('/IPA/') && canAccessIPA) return setTabValue(TABS.IPA);

    if (currentPath.includes('/ISA/') || permissions.PAN) return setTabValue(TABS.ISA);

    if (usuario?.servicoColeta) return setTabValue(TABS.SERVICO_COLETA);

    return setTabValue(TABS.NONE);
  };

  const checkPermision = () => {
    if (usuario && !usuario.usuarioAdministrador) {
      const { message } = new Exception('Você não tem permissão para acessar a área de configurações');
      AlertWithTimestamp({ message });
      history.push('/login');
    }
  };

  useEffect(() => {
    getProductConfigData();
  }, []);

  useEffect(() => {
    setStartTab(usuario);
    checkPermision();
  }, [usuario]);

  const backPage = () => {
    if (currentPath.includes(ROUTES.ISA_ANALISE_COBERTURAS)) {
      history.push(ROUTES.ADMINISTRADOR_PESSOAS);
    } else {
      history.goBack();
    }
  };

  return (
    <Container className="main-container upload-arquivos-page" maxWidth="xl">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Button onClick={backPage} startIcon={<ArrowBackIcon />} className="back-btn">
            Voltar
          </Button>
        </Grid>
        <Grid item xs={12}>
          <ProductConfigCard elevation={0}>
            <ProductConfigCardContent>
              <ProductConfigTitle variant="h6">Configurações de produto</ProductConfigTitle>
              <StyledTabs value={tabValue} onChange={handleChange} aria-label="styled tabs example" TabIndicatorProps={{ children: <span /> }}>
                <StyledTab label="ISA | InfoPanel" disabled={!permissions.PAN} {...a11yProps(0)} onClick={() => history.push(panelRoutes)} />
                <StyledTab label="ISA | Monitoramento em PDV" disabled={!usuario?.servicoColeta} {...a11yProps(1)} />
                <StyledTab label={ipaTabLabel} disabled={!permissions.IPA} data-testid="settings-tab-ipa" {...a11yProps(2)} />
              </StyledTabs>
            </ProductConfigCardContent>
          </ProductConfigCard>
        </Grid>
        <TabPanel value={tabValue} index={0}>
          {panelFree ? <InfoPanelConfig /> : <SetupInfopanel user={usuario} />}
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <MpdvConfig save={handleSaveProductConfig} data={productConfigData} />
        </TabPanel>
        <TabPanel className="setup-ipa-section" value={tabValue} index={2}>
          <SetupIPA usuario={usuario} />
        </TabPanel>
      </Grid>
    </Container>
  );
};

export default ProductsConfigPage;
